import { client } from "@/api/client";
import interceptors from "@/api/interceptor";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getSlider(params) {
	return client.get("seller/slider/data", {
		params: params,
	});
}
function getSliderDetail(params) {
	return client.get("seller/slider/detail", {
		params: params,
	});
}

function addSlider(params) {
	return client.post("seller/slider/add", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updateSlider(params) {
	return client.post("seller/slider/edit", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function statusSlider(params) {
	return client.post("seller/slider/status", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function removeSlider(params) {
	return client.post("seller/slider/delete", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function removeSliderImage(params) {
	return client.post("seller/slider/delete-image", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function uploadImage(params) {
	return client.post("seller/slider/upload-image", params, {
		header: {
			'Content-Type': 'multipart/form-data'
		}
	});
}

export default {
	getSlider,
	getSliderDetail,
	addSlider,
	updateSlider,
	statusSlider,
	removeSlider,
	removeSliderImage,
	uploadImage,
};